export const SET_LOADER_VISIBLE = "SET_LOADER_VISIBLE";

export const setLoaderVisible = payload => ({
  type: SET_LOADER_VISIBLE,
  payload
});
